document.addEventListener('DOMContentLoaded', function () {
  document.querySelector('.js-close-menu').addEventListener('click', function (e) {
    closeOpenedSubmenu();
  });

  document.querySelectorAll('.js-submenu-summary').forEach((submenuSummary) => {
    submenuSummary.addEventListener('click', function (e) {
      if (!this.parentElement.hasAttribute("open")) {
        closeOpenedSubmenu();
      }
    });
  });

  document.querySelectorAll('[back-to-menu]').forEach((backToMenu) => {
    backToMenu.addEventListener('click', function (e) {
      closeOpenedSubmenu();
    });
  });

  function closeOpenedSubmenu() {
    const submenuOpened = document.querySelector('.js-submenu[open]');
    if (submenuOpened) submenuOpened.removeAttribute("open");
  }

  document.querySelector('.mainMenu__main').classList.add('--loaded');
  document.querySelector('.mainMenu__content').classList.add('--loaded');
  document.querySelector('.mainMenu__bg').classList.add('--loaded');

  let inputMenuClose = document.querySelector('.js-menu-input-0');
  let inputsMenu = document.querySelectorAll('.js-menu-input-x');
  inputsMenu.forEach((inputMenu) => {
    inputMenu.addEventListener('change', function (e) {
      if (this.checked) {
        inputMenuClose.checked = false;
      }
    });
  });

  inputMenuClose.addEventListener('change', function (e) {
    if (this.checked) {
      inputsMenu.forEach((inputMenu) => {
        inputMenu.checked = false;
      });
    }
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.mainMenu');
  if (!menu) return;

  const update = () => {
    const atEnd = Math.ceil(menu.scrollTop + menu.clientHeight) >= menu.scrollHeight;
    menu.classList.toggle('--at-end', atEnd);
  };

  update();
  menu.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  new ResizeObserver(update).observe(menu);
});